export default "__VITE_ASSET__Bu_Q01bE__"